export default __webpack_public_path__ + "static/media/Statistics_2015.4c427d9e.zip";